import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProfile from "../common/MyProfile";
const SavedPayment = () => {
  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <div
          className="container mt-4 removetopspace "
          style={{ paddingTop: "170px" }}
        >
          <div className="row">
            <MyProfile />

            <div className="col-md-7">
              <h4 className="fw-bold">Saved Payments</h4>
              <div className="mb-3">
                <p className="fw-bold">
                  Bank Transfer{" "}
                  <span className="text-success float-end">Add</span>
                </p>
                <p className="fw-bold">
                  UPI <span className="text-success float-end">Add</span>
                </p>
              </div>

              <h5 className="fw-bold">Voucher</h5>
              <div className="row">
                {[
                  "Amazon Pay Gift Card",
                  "Flipkart Gift Card",
                  "Tata Cliq",
                  "Croma",
                  "Sangeetha Gift Card",
                  "Cashify Online Store Voucher",
                ].map((voucher, index) => (
                  <div className="col-md-4 mb-3" key={index}>
                    <div
                      className="card p-3 shadow-sm"
                      style={{ borderRadius: "10px" }}
                    >
                      <h6 className="mb-1">{voucher}</h6>
                      <small className="text-muted">Not linked yet.</small>
                      <span className="text-success float-end">Add</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SavedPayment;
